export default __webpack_public_path__ + "static/media/Shenlong_pfp.73b0a944.png";